import React from 'react';

import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

function PackageType(props) {
    const {
        volumeKey,
        price,
        currencySymbol,
        selectedVolumeCost,
        setVolumeKey,
        setSelectedVolumeCost,
        data: { key, index, packageImage },
        disabled,
    } = props;


    let priceText = '';
    if (disabled){
        priceText = 'Not available';
    } else if (volumeKey === index) {
        priceText = `${currencySymbol}${price}`;
    } else if (price < selectedVolumeCost) {
        priceText = `- ${currencySymbol}${(selectedVolumeCost-price).toFixed(2)}`;
    } else if (price > selectedVolumeCost) {
        priceText = `+ ${currencySymbol}${(price-selectedVolumeCost).toFixed(2)}`;
    } else {
        priceText = `${currencySymbol}0 additional cost`;
    }
    return (
        <Paper
            onClick={() => {
                if (!disabled){
                    setVolumeKey(index);
                    setSelectedVolumeCost(price);
                    // setTimingCost(distanceWeightCost + additionalPrice);
                }
            }}
            elevation={volumeKey === index ? 5 : 0}
            key={index}
            sx={{
                cursor: 'pointer',
                height: '100%',
                width: '100%',
                fontWeight: {
                    sm: 600,
                    md: 500,
                },
                backgroundColor: theme =>
                    `${volumeKey === index ? alpha(theme.palette.secondary.main, 0.08) : '#e3e3e3'}`,
                color: '#000000',
                border: theme => `${volumeKey === index ? `2px solid ${theme.palette.secondary.main}` : 'none'}`,
            }}
        >
            <Stack
                direction={{ xs: 'row', sm: 'row', md: 'column' }}
                spacing={2}
                justifyContent={'space-around'}
                alignItems={'center'}
                sx={{
                    height: {
                        xs: '120px',
                        sm: '120px',
                        md: '100%',
                        lg: '100%',
                    },
                    maxHeight: {
                        xs: '120px',
                        sm: '120px',
                        md: '100%',
                        lg: '100%',
                    },
                }}
            >
                <Typography marginTop={'16px'}>{key}</Typography>
                {packageImage}
            </Stack>
            <Button
                disableElevation={true}
                fullWidth
                color={'secondary'}
                disabled={disabled}
                sx={{
                    // border: theme => disabled ? `1px solid ${theme.palette.disabled.dark}` : `1px solid ${theme.palette.secondary.main}`,
                    fontWeight: volumeKey === index ? 600 : 500,
                    borderRadius: 0,
                    borderBottomLeftRadius:`${volumeKey !== index ? '5px' : '0px'}`,
                    borderBottomRightRadius:`${volumeKey !== index ? '5px' : '0px'}`,
                }}
                variant={'contained'}
            >
                {priceText}
            </Button>
            {/*</Box>*/}
            {/*</Stack>*/}
        </Paper>
        // </Box>
    );
}

export default PackageType;
